/** @jsxImportSource @emotion/react */
"use client";

import type { Interpolation } from "@emotion/react";
import type { BibleManifest, BibleTranslations } from "@packages/sdk";
import { usePathMatch } from "@packages/sdk";
import type { ThemeType } from "@packages/ui";
import { useParams } from "next/navigation";
import { useContext } from "react";

import { BibleHeaderContext } from "../BibleHeaderContext";
import { BibleLink } from "../BibleLink";
import { BibleNavigation } from "../BibleNavigation";
import { DailyReadingNavigation } from "../DailyReadingNavigation";

const headerStyle: Interpolation<ThemeType> = (theme) => ({
  alignItems: "center",
  background: theme.semanticColors.background,
  display: "flex",
  flexDirection: "row",
  flexWrap: "nowrap",
  height: "56px",
  justifyContent: "space-between",
  marginInline: "auto",
  maxWidth: "720px",
  padding: `${theme.spacing.s} 0`,
  position: "sticky",
  top: theme.spacing.xxxl,
  width: "95vw",
  transition: "top 200ms ease-in-out",
  zIndex: theme.zIndices[2],
});

type BibleNavigationHeaderProps = {
  manifest?: BibleManifest;
  tid?: number;
  translations?: BibleTranslations["translations"];
};

export const BibleNavigationHeader = ({
  manifest,
  tid,
  translations,
}: BibleNavigationHeaderProps) => {
  const { date } = useParams();
  const match = usePathMatch();
  const variant = match("/bible/daily-readings") ? "daily-readings" : "bible";
  const { clearSelection } = useContext(BibleHeaderContext);

  return (
    <div css={headerStyle} onClick={() => clearSelection()}>
      <BibleLink variant={variant} />

      {variant === "daily-readings" ? (
        <DailyReadingNavigation date={date} />
      ) : (
        <BibleNavigation
          translations={translations}
          tid={tid}
          manifest={manifest}
        />
      )}
    </div>
  );
};
